<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 125 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M124.262 107.599L107.645 78.8173L103.192 71.1054H85.4734L62.1082 30.7098L38.789 71.1054H29.9295L62.1082 15.3779L89.8802 63.4394H98.7397L62.1082 0L16.6173 78.8173H34.3822L26.5785 92.2672H35.438L43.2416 78.8173H81.0207L88.7785 92.2672H97.6839L89.8802 78.8173H98.7397L110.95 99.9332H13.3122L21.07 86.4833H12.2105L0 107.599H124.262ZM76.6139 71.1054H47.6484L62.1082 46.0877L76.6139 71.1054Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 36 },
    height: { type: [Number, String], default: 34 },
    color: { type: String, default: "#D3D4DE" },
  },
};
</script>
